// Utilitaires WhatsApp partagés (liens wa.me, normalisation des numéros RDC).
// Approche « lien profond » : le message est pré-rempli, l'humain appuie sur Envoyer
// (aucun envoi automatique — conforme aux règles Ndoé).

// Normalise un numéro pour wa.me : chiffres uniquement, format international RDC (243…).
// 0812345678 -> 243812345678 ; +243 81 234 5678 -> 243812345678 ; 812345678 -> 243812345678.
export const normalizePhoneCd = (raw) => {
  const digits = String(raw || '').replace(/\D/g, '');
  if (!digits) return '';
  if (digits.startsWith('243')) return digits;
  if (digits.startsWith('0')) return `243${digits.slice(1)}`;
  return `243${digits}`;
};

// Construit un lien wa.me avec message pré-rempli et encodé. Retourne '' si pas de numéro.
export const buildWaLink = (phone, text = '') => {
  const num = normalizePhoneCd(phone);
  if (!num) return '';
  const query = text ? `?text=${encodeURIComponent(text)}` : '';
  return `https://wa.me/${num}${query}`;
};

// Remplace les jetons {clef} d'un gabarit par les valeurs fournies (ce qui manque -> vide).
export const renderTemplate = (template, values = {}) =>
  String(template || '').replace(/\{(\w+)\}/g, (_, key) => (values[key] != null ? String(values[key]) : ''));
